const redirectToApp = (app: string, route = '', query: Record<string, string> = {}): void => {
  const { origin } = window.location;
  const url = new URL(`${origin}/${app}/${route}`);

  Object.entries(query).forEach(([queryParamName, queryParamValue]) => {
    url.searchParams.append(queryParamName, queryParamValue);
  });

  window.location.replace(url.href);
};

export default redirectToApp;
